import { PsResourceCompany } from '../../shared/model/resource/PsResourceCompany';
import { PsResourceDocumentation } from '../../shared/model/resource/PsResourceDocumentation';
import WorkerState from '../../shared/model/WorkerState';
import WorkerContractorState from '../../shared/model/WorkerContractorState';

export class PsWorker {

    _id; // number
    _dni; // string
    _job; // string
    _name; // string
    _active; // boolean
    _company; // PsResourceCompany
    _lastName; // string
    _agreement; // string
    _contractor; // PsResourceCompany
    _documentation; // PsResourceDocumentation

    constructor(
        id,
        dni,
        job,
        name,
        active,
        company,
        lastName,
        agreement,
        contractor,
        documentation,
    ) {
        this._id = id;
        this._dni = dni;
        this._job = job;
        this._name = name;
        this._active = active;
        this._company = company;
        this._lastName = lastName;
        this._agreement = agreement;
        this._contractor = contractor;
        this._documentation = documentation;
    }

    static fromAPIWorkers(workers) {
        return workers.map((worker) => PsWorker.fromAPIWorker(worker));
    }

    static fromAPIWorker(worker) {
        const { contractors, worker_documentation_state: state } = worker;
        let active;
        if (worker.worker_contractor_state) {
            active = worker.worker_contractor_state.id === WorkerContractorState.ACTIVE;
        } else {
            active = worker.worker_state.id === WorkerState.ACTIVE;
        }

        return new this(
            worker.id,
            worker.dni,
            worker.position || '',
            worker.name || '',
            active,
            worker.company ? PsResourceCompany.fromAPICompany(worker.company) : PsResourceCompany.null(),
            worker.last_name || '',
            worker.agreement || '',
            worker.contractor ? PsResourceCompany.fromAPICompany(worker.contractor) : PsResourceCompany.null(),
            PsResourceDocumentation.fromAPIContractorResource(contractors, state),
        );
    }

    id() {
        return this._id;
    }

    dni() {
        return this._dni;
    }

    job() {
        return this.documentation()._position;
    }

    name() {
        return this._name;
    }

    lastName() {
        return this._lastName;
    }

    completeName() {
        return `${this.name()} ${this.lastName()}`;
    }

    agreement() {
        return this._agreement;
    }

    isActive() {
        return this._active;
    }

    company() {
        return this._company;
    }

    companyId() {
        return this.company().id();
    }

    contractor() {
        return this._contractor;
    }

    contractorId() {
        return this.contractor().id();
    }

    companyDescription() {
        return this.company().description();
    }

    documentation() {
        return this._documentation;
    }

    documentationDescription() {
        return this.documentation().schemasDescription();
    }

    documentationWorkerPosition() {
        return this.documentation().schemasPosition()
    }

    documentationStateData() {
        return this.documentation().stateData();
    }
}



// WEBPACK FOOTER //
// ./src/app/my-contractors/worker/PsWorker.js